export const PostHogEvent = {
  SignUpButtonClicked: 'sign_up_button_clicked',
  UserLoggedIn: 'user_logged_in',
  UserSignedUp: 'user_signed_up'
} as const;

export type PostHogEvent = (typeof PostHogEvent)[keyof typeof PostHogEvent];

export const PostHogGroup = {
  Organization: 'organization'
} as const;

export type PostHogGroup = (typeof PostHogGroup)[keyof typeof PostHogGroup];
